import { render } from "./EstimateReceivedIcon.vue?vue&type=template&id=dfe380ac"
import script from "./EstimateReceivedIcon.vue?vue&type=script&lang=js"
export * from "./EstimateReceivedIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__